const pageNameKey = "organizationsViewAdminPanel";

export const organizationsViewAdminPanelEn = {
  [pageNameKey]: {
    title: "Organizations",
    description:
      "View organizations and their classifications: supplier, OEM, distributor, or factory.",
  },
};

export const organizationsViewAdminPanelPtBr = {
  [pageNameKey]: {
    title: "Organizações",
    description:
      "Veja as organizações e suas classificações: fornecedor, OEM, distribuidor ou fábrica.",
  },
};

export const organizationsViewAdminPanelDe = {
  [pageNameKey]: {
    title: "Organisationen",
    description:
      "Organisationen und ihre Klassifizierungen anzeigen: Lieferant, OEM, Distributor oder Werk.",
  },
};

export const organizationsViewAdminPanelZhHans = {
  [pageNameKey]: {
    title: "组织",
    description: "查看组织及其分类：供应商、OEM、经销商或工厂。",
  },
};

export const organizationsViewAdminPanelEs = {
  [pageNameKey]: {
    title: "Organizaciones",
    description:
      "Ver las organizaciones y sus clasificaciones: proveedor, OEM, distribuidor o fábrica.",
  },
};

export const organizationsViewAdminPanelIt = {
  [pageNameKey]: {
    title: "Organizzazioni",
    description:
      "Visualizza le organizzazioni e le relative classificazioni: fornitore, OEM, distributore o stabilimento.",
  },
};

export const organizationsViewAdminPanelNl = {
  [pageNameKey]: {
    title: "Organisaties",
    description:
      "Bekijk organisaties en hun classificaties: leverancier, OEM, distributeur of fabriek.",
  },
};

export const organizationsViewAdminPanelTr = {
  [pageNameKey]: {
    title: "Organizasyonlar",
    description:
      "Organizasyonları ve sınıflandırmalarını görüntüleyin: tedarikçi, OEM, distribütör veya fabrika.",
  },
};
